export default __webpack_public_path__ + "79f179d.png";